// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fC","advertDetailServiceList__header":"c-o_fE","advertDetailServiceList__list":"c-o_fF"};